// extracted by mini-css-extract-plugin
export default {"main":"PlayerHandCards_main__JNEa6","hide":"PlayerHandCards_hide__txLAx","card":"PlayerHandCards_card__ZqcZU"};